export const tablet = 768;
export const mobile = 425;
